let data = [
  { heading: "Product Id", value: "206824" },
  { heading: "Model No.", value: "LA E15417" },
  { heading: "Frame Size", value: "Medium" },
  { heading: "Frame Width", value: "139 mm" },
  { heading: "Frame Dimensions", value: "50-20-145" },
  { heading: "Frame colour", value: "Amber" },
];

export default data;
